import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import TagManager from 'react-gtm-module';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { FORMS, USER_ROLE_TYPES } from '../../../../constants';
import FieldsGroupOne from '../FieldsGroupOne';
import FieldsGroupTwo from '../FieldsGroupTwo';
import FieldsGroupThree from '../FieldsGroupThree';
import FieldsGroupFour from '../FieldsGroupFour';
import {
  setRegistrationInfo,
  resetRegistrationInfo,
} from '../../../../store/actions/registration';
import { validateEmailUnique } from '../../../../utilities/validators';
import { constructGTM } from '../../../../utilities/helpers';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    firstRow: PropTypes.string,
    fieldsGroupOne: PropTypes.string,
    fieldsGroupTwo: PropTypes.string,
  }).isRequired,
  initialValues: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  touch: PropTypes.func.isRequired,
};

const asyncValidate = values =>
  validateEmailUnique('custom:personalEmail', values);

const onSubmitFail = errors => {
  // Log failed event to GTM
  TagManager.initialize(
    constructGTM({
      dataLayer: {
        event: 'Registration step 2/3 - error',
        errorsReg2: errors,
      },
    }),
  );
};

export const RegistrationForm = props => {
  const { handleSubmit, classes, change, touch, initialValues } = props;

  const isBuilder =
    initialValues['custom:roleType'] === USER_ROLE_TYPES.BUILDER.code;
  return (
    <form onSubmit={handleSubmit}>
      <div className={classes.firstRow}>
        <div className={classes.fieldsGroupOne}>
          <FieldsGroupOne isBuilder={isBuilder} changeFieldValue={change} />
        </div>
        <div className={classes.fieldsGroupTwo}>
          <FieldsGroupTwo isBuilder={isBuilder} />
        </div>
      </div>
      {isBuilder && (
        <>
          <div
            className={classes.secondRow}
            data-test="fieldsGroupThree-fields"
          >
            <div className={classes.fieldsGroupThree}>
              <FieldsGroupThree changeFieldValue={change} touchField={touch} />
            </div>
          </div>
          <div
            className={classes.secondRow}
            data-test="fieldsGroupThree-fields"
          >
            <div className={classes.fieldsGroupThree}>
              <FieldsGroupFour changeFieldValue={change} touchField={touch} />
            </div>
          </div>
        </>
      )}
    </form>
  );
};

RegistrationForm.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onSetRegistrationInfo: info => dispatch(setRegistrationInfo(info)),
  onResetRegistrationInfo: () => dispatch(resetRegistrationInfo()),
});

export default reduxForm({
  form: FORMS.REGISTRATION_LONG,
  asyncValidate,
  asyncBlurFields: ['custom:personalEmail'],
  onSubmitFail,
})(
  withStyles(styles)(
    connect(
      null,
      mapDispatchToProps,
    )(RegistrationForm),
  ),
);
